namespace TabAurous.Retail {
    export interface GiftVoucherItemsRow {
        TransItemId?: number;
        TransId?: number;
        GiftMasterId?: number;
        Quantity?: number;
        ItemDetails?: GiftVoucherItemDetailsRow[];
    }

    export namespace GiftVoucherItemsRow {
        export const idProperty = 'TransItemId';
        export const localTextPrefix = 'Retail.GiftVoucherItems';
        export const deletePermission = 'Retail:GiftVoucherIssue:Delete';
        export const insertPermission = 'Retail:GiftVoucherIssue:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:GiftVoucherIssue:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            GiftMasterId = "GiftMasterId",
            Quantity = "Quantity",
            ItemDetails = "ItemDetails"
        }
    }
}
